import Vue from 'vue'
import Vuex from 'vuex'
import AuthModule from 'inomph-auth'
import VueModalStore from 'vue-modal/dist/vue-modal-store'
import ConfigStore from './config'
import ModalStore from './modal'
require('grapesjs-preset-newsletter')

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {

  },
  actions: {
    userChanged (context, user) {
      // console.log(user)
    }
  }
})

store.registerModule('auth', AuthModule({
  endpoint: `${process.env.API_URL}/auth/token`
}))

store.registerModule('modal', VueModalStore(Vue))
store.registerModule('config', ConfigStore())
store.registerModule('_modal', ModalStore())
store.dispatch('auth/restore')

export default store



// WEBPACK FOOTER //
// ./src/store/index.js